import axios from "axios";
import config from "../../config";
import {
  ClientsResponse,
  ClientScoringRulesResponse,
  ClientScoringRule,
  ClientScoringRuleUpdate,
  ClientScoringRuleState,
  ClientScoringRuleBulkUpdate,
  ClientIdsResponse,
} from "./types";

const apiUrl = config.api;

const getClients = async (): Promise<ClientsResponse> => {
  const response = await axios.get<ClientsResponse>(`${apiUrl}/clients`);
  return response.data;
};

const getClientScoringRules = async (
  clientId: number,
): Promise<ClientScoringRule[]> => {
  const response = await axios.get<ClientScoringRulesResponse>(
    `${apiUrl}/clients/${clientId}/scoring`,
  );
  return response.data.results;
};

const updateClientScoringRule = async (
  update: ClientScoringRuleUpdate,
): Promise<void> => {
  const response = await axios.put(
    `${apiUrl}/clients/${update.clientId}/scoring/${update.scoringRuleId}`,
    update,
  );
  return response.data;
};

const getClientIdsIgnoringRule = async (ruleId: number): Promise<number[]> => {
  const response = await axios.get<ClientIdsResponse>(
    `${apiUrl}/scoring/rules/${ruleId}/clients`,
  );
  return response.data.results;
};

const bulkUpdateClientScoringRule = async (
  ruleId: number,
  clients: ClientScoringRuleState[],
): Promise<void> => {
  const body: ClientScoringRuleBulkUpdate = { clients };
  await axios.put(`${apiUrl}/scoring/rules/${ruleId}/clients`, body);
};

export {
  getClients,
  getClientScoringRules,
  updateClientScoringRule,
  getClientIdsIgnoringRule,
  bulkUpdateClientScoringRule,
};
